import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface ActualizarActividadAprendizPayload {
  actividadAprendizId?: number;
  idActividad?: number;
  idAprendiz?: number;
  intentos?: number;
  intentosExtras?: number;
  historialChat?:
    | {
        role: string;
        content: string;
      }
    | {
        role: string;
        content: string;
      }[];
}

export interface ActividadAprendizActualizada {
  id: number;
  intentos: number;
  intentosExtras: number;
  historialChat: unknown;
  actualizadoEl: string;
}

export function useActualizarActividadAprendiz(invalidateProgramaId?: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      payload: ActualizarActividadAprendizPayload
    ): Promise<ActividadAprendizActualizada> => {
      const { actividadAprendizId, ...data } = payload;
      const response = await axiosInstance.patch(
        `/actividades-aprendiz/${actividadAprendizId}`,
        data
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      if (invalidateProgramaId != null) {
        queryClient.invalidateQueries({
          queryKey: [
            "actividadesAprendiz",
            variables.idAprendiz,
            invalidateProgramaId,
          ],
        });
      }
    },
  });
}
